// @ts-nocheck
(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-qbs-buy-together]";
  var ITEM_CONTAINER_SELECTOR = "[data-qbs-buy-together-items]";
  var TOTAL_SELECTOR = "[data-qbs-buy-together-total]";
  var ADD_BUTTON_SELECTOR = "[data-qbs-buy-together-add]";

  function parseProductId(node) {
    if (!node) return "";
    var className = node.className || "";
    var match = className.match(/product-id-(\d+)/);
    return match ? match[1] : "";
  }

  function moneyText(node) {
    if (!node) return "";
    var amount = node.querySelector(".rebuy-money span:last-child");
    return (amount ? amount.textContent : node.textContent || "").trim();
  }

  function debounceFrame(fn) {
    var raf = 0;
    return function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        fn();
      });
    };
  }

  function ProductData(sourceBlock, imageNode, index, cachedImage) {
    var titleLink = sourceBlock.querySelector(".rebuy-product-title-link");
    var priceNode = sourceBlock.querySelector(".rebuy-product-price");
    var checkbox = sourceBlock.querySelector(".rebuy-checkbox");
    var select = sourceBlock.querySelector("select.rebuy-select");
    var pid = parseProductId(sourceBlock) || (checkbox && checkbox.id ? checkbox.id.replace("checkbox-", "") : String(index));

    this.index = index;
    this.productId = pid;
    this.sourceBlock = sourceBlock;
    this.checkbox = checkbox;
    this.select = select;
    this.title = (titleLink ? titleLink.textContent : "").trim() || "Product";
    this.url = titleLink ? titleLink.getAttribute("href") : "#";
    this.price = moneyText(priceNode);
    this.category = "Product";
    this.selected = sourceBlock.classList.contains("is-selected") || (checkbox ? checkbox.checked : true);
    this.isInputProduct = sourceBlock.classList.contains("is-input-product");
    // Порядок пошуку зображення:
    // 1) вузол зі списку .rebuy-bundle__images, зіставлений за product id;
    // 2) кеш — Rebuy прибирає зображення знятого з набору товару з того списку;
    // 3) картинка всередині самого блоку товару — рятує випадок, коли товар був
    //    знятий уже на момент завантаження і в кеш потрапити не встиг.
    var liveImage = imageNode ? imageNode.querySelector("img") : null;
    this.image = liveImage || cachedImage || sourceBlock.querySelector(".rebuy-product-image img, img") || null;
  }

  function buildCard(item, isLast) {
    var article = document.createElement("article");
    article.className = "buy-together__product together-product";
    article.setAttribute("data-one-select", "");
    article.dataset.pid = item.productId;
    if (!item.selected) article.classList.add("is-unselected");

    var top = document.createElement("div");
    top.className = "together-product__top";

    var imageLink = document.createElement("a");
    imageLink.className = "together-product__image";
    imageLink.href = item.url || "#";
    if (item.image) {
      var img = item.image.cloneNode(true);
      img.classList.add("ibg");
      imageLink.appendChild(img);
    }

    var plus = document.createElement("span");
    plus.className = "together-product__plus asset-button _icon-plus";
    plus.setAttribute("aria-hidden", "true");
    if (isLast) plus.style.visibility = "hidden";

    top.appendChild(imageLink);
    top.appendChild(plus);

    // The current/input product is mandatory in the bundle, so it gets no toggle.
    if (!item.isInputProduct && item.checkbox) {
      var toggleLabel = document.createElement("label");
      toggleLabel.className = "together-product__toggle";

      var toggleInput = document.createElement("input");
      toggleInput.type = "checkbox";
      toggleInput.className = "together-product__toggle-input";
      toggleInput.checked = item.selected;
      toggleInput.setAttribute(
        "aria-label",
        item.selected ? "Remove " + item.title + " from bundle" : "Add " + item.title + " to bundle"
      );

      toggleLabel.appendChild(toggleInput);
      toggleLabel.appendChild(document.createElement("span"));
      top.appendChild(toggleLabel);
    }

    var content = document.createElement("div");
    content.className = "together-product__content";
    content.setAttribute("data-da", ".buy-together__mobile,992");

    var category = document.createElement("a");
    category.className = "together-product__category";
    category.href = item.url || "#";
    category.textContent = item.category;

    var body = document.createElement("div");
    body.className = "together-product__body";

    var titleA = document.createElement("a");
    titleA.className = "together-product__title";
    titleA.href = item.url || "#";
    var h3 = document.createElement("h3");
    h3.textContent = item.title;
    titleA.appendChild(h3);

    var price = document.createElement("div");
    price.className = "together-product__price price";
    price.textContent = item.price;

    body.appendChild(titleA);
    body.appendChild(price);

    content.appendChild(category);
    content.appendChild(body);

    if (item.select) {
      var selectClone = item.select.cloneNode(true);
      selectClone.setAttribute("data-class-modif", "red");
      selectClone.setAttribute("data-show-selected", "");
      selectClone.classList.add("qbs-buy-together__variant");
      content.appendChild(selectClone);
    }

    article.appendChild(top);
    article.appendChild(content);
    return article;
  }

  function initSection(root) {
    if (!root || root.dataset.qbsBuyTogetherReady === "true") return;
    root.dataset.qbsBuyTogetherReady = "true";

    var widgetId = (root.dataset.widgetId || "").trim();
    var hideWidget = root.dataset.hideWidget === "true";
    var showCurrentProduct = root.dataset.showCurrentProduct === "true";

    var itemContainer = root.querySelector(ITEM_CONTAINER_SELECTOR);
    var totalNode = root.querySelector(TOTAL_SELECTOR);
    var addButton = root.querySelector(ADD_BUTTON_SELECTOR);

    if (!itemContainer || !totalNode || !addButton) return;

    var sourceWidget = null;
    var observer = null;
    var observerLockUntil = 0;
    var lastSignature = "";
    var selectInitCounter = 10000;
    var selectMap = new Map();
    // Rebuy прибирає зображення знятого з набору товару з .rebuy-bundle__images,
    // тому кешуємо їх за product id і показуємо з кешу, коли вузол зник.
    var imageCache = new Map();

    function findWidget() {
      sourceWidget = null;
      if (widgetId) {
        sourceWidget =
          root.querySelector("#rebuy-widget-" + widgetId) ||
          document.getElementById("rebuy-widget-" + widgetId);
      }
      if (!sourceWidget) return false;
      if (hideWidget) sourceWidget.classList.add("qbs-rebuy-source-hidden");
      return true;
    }

    function getItems() {
      if (!sourceWidget) return [];
      var blocks = sourceWidget.querySelectorAll(".rebuy-bundle__items .rebuy-product-block");
      var images = sourceWidget.querySelectorAll(".rebuy-bundle__images .rebuy-bundle__image");
      var imagesByPid = {};
      images.forEach(function (node) {
        var pid = parseProductId(node);
        if (!pid) return;
        imagesByPid[pid] = node;
        // Запам'ятовуємо саме <img>, бо сам вузол Rebuy може видалити з DOM.
        var img = node.querySelector("img");
        if (img) imageCache.set(pid, img.cloneNode(true));
      });
      var out = [];
      blocks.forEach(function (block, index) {
        if (!showCurrentProduct && block.classList.contains("is-input-product")) return;
        var pid = parseProductId(block);
        // Прив'язка тільки за product id: списки блоків і зображень мають різну
        // довжину (зняті товари зникають зі списку зображень), тож зіставлення
        // за позицією підставляло б картинку сусіднього товару.
        var imageNode = pid ? imagesByPid[pid] || null : null;
        out.push(new ProductData(block, imageNode, index, pid ? imageCache.get(pid) : null));
      });
      return out;
    }

    function getSignature(items) {
      var total = "";
      if (sourceWidget) {
        var sourceTotal = sourceWidget.querySelector(".rebuy-bundle__actions-price-value");
        total = moneyText(sourceTotal);
      }
      var body = items
        .map(function (item) {
          var variantValue = item.select ? item.select.value : "";
          return [ item.productId, item.selected ? "1" : "0", variantValue, item.price ].join(":");
        })
        .join("|");
      return body + "||" + total;
    }

    function enhanceSelects(scope) {
      var selects = scope.querySelectorAll("select[data-class-modif='red']");
      if (!selects.length) return;
      if (!window.flsModules || !window.flsModules.select) return;
      var initializedCount = 0;
      selects.forEach(function (select) {
        if (select.dataset.qbsSelectInit === "true") return;
        select.dataset.qbsSelectInit = "true";
        selectInitCounter += 1;
        initializedCount += 1;
        window.flsModules.select.selectInit(select, selectInitCounter);
      });

      // Ensure selects are never rendered in an opened state by default.
      var opened = scope.querySelectorAll(".select._select-open");
      var openedCount = opened.length;
      opened.forEach(function (selectItem) {
        selectItem.classList.remove("_select-open");
        var options = selectItem.querySelector(".select__options");
        if (options) {
          options.hidden = true;
        }
      });
    }

    function syncTotal() {
      if (!sourceWidget) return;
      var sourceTotal = sourceWidget.querySelector(".rebuy-bundle__actions-price-value");
      if (!sourceTotal) return;
      totalNode.textContent = moneyText(sourceTotal);
    }

    function syncAddState(items) {
      var hasSelected = items.some(function (item) {
        return item.selected;
      });
      addButton.disabled = !hasSelected;
    }

    function render() {
      if (!findWidget()) {
        itemContainer.innerHTML = "";
        addButton.disabled = true;
        root.classList.remove("is-ready");
        lastSignature = "";
        return;
      }

      var items = getItems();
      var currentSignature = getSignature(items);
      if (currentSignature === lastSignature) return;
      lastSignature = currentSignature;

      itemContainer.innerHTML = "";
      selectMap.clear();

      if (!items.length) {
        addButton.disabled = true;
        root.classList.remove("is-ready");
        return;
      }

      root.classList.add("is-ready");

      items.forEach(function (item, idx) {
        var card = buildCard(item, idx === items.length - 1);
        itemContainer.appendChild(card);

        var toggleInput = card.querySelector(".together-product__toggle-input");
        var selectClone = card.querySelector(".qbs-buy-together__variant");

        if (toggleInput) {
          toggleInput.addEventListener("change", function () {
            if (!item.checkbox || item.isInputProduct) return;
            observerLockUntil = Date.now() + 220;
            card.classList.toggle("is-unselected", !toggleInput.checked);
            item.checkbox.click();
          });
        }

        if (selectClone && item.select) {
          selectClone.value = item.select.value;
          selectMap.set(selectClone, item.select);
        }
      });

      enhanceSelects(itemContainer);

      syncTotal();
      syncAddState(items);
    }

    function onSelectCallback(e) {
      try {
        if (!e || !e.detail || !e.detail.select) return;
        var changedSelect = e.detail.select;
        if (!changedSelect || !selectMap.has(changedSelect)) return;
        var targetRebuySelect = selectMap.get(changedSelect);
        if (!targetRebuySelect) return;

        var desired = changedSelect.value;
        observerLockUntil = Date.now() + 220;

        targetRebuySelect.value = desired;
        targetRebuySelect.dispatchEvent(new Event("input", { bubbles: true }));
        targetRebuySelect.dispatchEvent(new Event("change", { bubbles: true }));
        rerender();
        setTimeout(rerender, 120);
        setTimeout(rerender, 320);
      } catch (err) {}
    }

    addButton.addEventListener("click", function () {
      if (!findWidget()) return;
      var sourceAdd = sourceWidget.querySelector(".rebuy-bundle__actions-buttons .rebuy-button");
      if (sourceAdd) sourceAdd.click();
    });

    var rerender = debounceFrame(render);
    render();
    document.addEventListener("selectCallback", onSelectCallback);

    var setupInterval = setInterval(function () {
      if (!findWidget()) return;
      clearInterval(setupInterval);
      observer = new MutationObserver(function (mutations) {
        if (Date.now() < observerLockUntil) {
          setTimeout(rerender, observerLockUntil - Date.now() + 20);
          return;
        }
        for (var i = 0; i < mutations.length; i += 1) {
          var mutation = mutations[i];
          if (mutation.type === "childList" || mutation.type === "characterData") {
            rerender();
            return;
          }
          if (mutation.type === "attributes") {
            var target = mutation.target;
            var hasClassList = !!(target && target.classList);
            if (
              (hasClassList && (target.classList.contains("rebuy-product-block") || target.classList.contains("rebuy-bundle__actions-price-value"))) ||
              (hasClassList && target.classList.contains("rebuy-checkbox")) ||
              (hasClassList && target.classList.contains("rebuy-select"))
            ) {
              rerender();
              return;
            }
          }
        }
      });
      observer.observe(sourceWidget, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: [ "class", "checked", "value" ]
      });
      rerender();
    }, 300);

    setTimeout(function () {
      clearInterval(setupInterval);
    }, 12000);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
